import React from "react";
import { Tooltip } from "antd";
import { HiOutlineLocationMarker } from "react-icons/hi";
import { MdOutlineBusinessCenter } from "react-icons/md";
import { AiFillStar } from "react-icons/ai";

export default function ManageJobCardSummary({
  title,
  facilityName,
  location,
  relativeTime,
  rating,
  reviews,
  isPrivate,
  vms,
  skillChips,
}) {
  const ratingValue =
    typeof rating === "number"
      ? (rating === 0 ? null : rating.toFixed(1))
      : rating || "4.8";
  const reviewCount = Number.isFinite(Number(reviews))
    ? String(Number(reviews)).padStart(2, "0")
    : "05";

  return (
    <div className="manage-job-card__summary">
      <div className="manage-job-card__summary-top">
        <div className="manage-job-card__summary-top-left">
          <div className="manage-job-card__facility-icon-box">
            <MdOutlineBusinessCenter className="manage-job-card__facility-icon" />
          </div>

          <div className="manage-job-card__title-block">
            <Tooltip title={title}>
              <h3 className="manage-job-card__title">{title}</h3>
            </Tooltip>
            <div className="manage-job-card__subtitle">{facilityName}</div>
          </div>
        </div>

        {ratingValue != null && (
          <div className="manage-job-card__rating">
            <AiFillStar className="manage-job-card__rating-icon" />
            <span className="manage-job-card__rating-value">{ratingValue}</span>
            <span className="manage-job-card__rating-reviews">({reviewCount} reviews)</span>
          </div>
        )}
      </div>

      <div className="manage-job-card__meta-row">
        {/* A remote job has no location — drop the pin with it, but keep the
            wrapper so the relative time stays on the right. */}
        <div className="manage-job-card__location">
          {location ? (
            <>
              <HiOutlineLocationMarker className="manage-job-card__location-icon" />
              <span className="manage-job-card__location-text">{location}</span>
            </>
          ) : null}
        </div>
        <span className="manage-job-card__time-text">{relativeTime}</span>
      </div>

      <div className="manage-job-card__chip-row">
        {isPrivate ? <span className="manage-job-card__chip manage-job-card__chip--private">Private</span> : null}
        {vms ? <span className="manage-job-card__chip manage-job-card__chip--soft">{vms}</span> : null}
      </div>
    </div>
  );
}
